import { useEffect, useState } from "react";
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import AlertMessage from "../include/AlertMessage";
import ConfirmationPopup from "../include/ConfirmationPopup"; // ⬅️ Import new popup
import Pagination from "../Pagination";
import { useAuth } from "../../context/AuthContext";

var _ = require('lodash');

function Artists() {
  const [allArtists, setallArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = sessionStorage.getItem('JWT_TOKEN');
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [showPopup, setShowPopup] = useState(false); // popup state
  const [deleteId, setDeleteId] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalArtists, setTotalArtists] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;

  const LIMIT = 10;

  const { role } = useAuth();

  const fetchArtists = async (page = currentPage) => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/artists`, {
        params: {
          page,
          limit: LIMIT
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token // Replace with your token
        }
      });

      const data = response.data?.documents || [];
      if (Array.isArray(data) && data.length > 0) {
        setallArtists(data);
        setTotalPages(response.data.pagination.totalPages);
        setTotalArtists(response.data.pagination.total);
      } else {
        setallArtists([]);
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    document.documentElement.className = "";

    fetchArtists(currentPage);
  }, [currentPage]);

  const handleDelete = async (id) => {
    if (!deleteId) return;
    try {
      setDeleting(true);
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/deleteartist/${deleteId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token // Replace with your token
          }
        }
      );

      if (response.status === 200 || response.status === 201) {
        const updatedData = allArtists.filter(artist => artist.$id !== deleteId);

        setallArtists(updatedData);

        setAlert({ type: "success", message: "Artist deleted successfully!" });

        // ⭐ If page becomes empty go to previous page
        if (updatedData.length === 0 && currentPage > 1) {
          setSearchParams({
            page: currentPage - 1
          });
        }
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
    } finally {
      setShowPopup(false); // close popup after action
      setDeleteId(null); // reset id
      setDeleting(false);
    }
  };

  //const visiblePages = getPagination(currentPage, totalPages);

  return (
    <section>
      <div className="is-title-bar">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
          <ul>
            <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
            <li>Artists</li>
          </ul>
          {["admin", "artist", "agent", "organization"].includes(role) && (
            <Link to="/artist/add" className='button blue'>Add Artist</Link>
          )}
        </div>
      </div>
      <div className="section main-section">
        <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
          <div className="card">
            <header className="card-header">
              <p className="card-header-title">
                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                Artists
              </p>
            </header>
            <div className="card-content">
              {alert.message && (
                <AlertMessage
                  type={alert.type}
                  message={alert.message}
                  onClose={() => setAlert({ type: "", message: "" })}
                  duration={3000}
                />
              )}
              {loading ? (
                <div className="flex justify-center items-center py-10">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                </div>

              ) : (
                Array.isArray(allArtists) && allArtists.length > 0 ? (
                  <>
                    <table>
                      <thead>
                        <tr>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {(allArtists || []).map((item, index) => (
                          <tr key={item.$id}>
                            <td data-label="name">{item.firstName}</td>
                            <td data-label="name">{item.lastName}</td>
                            <td className="actions-cell">
                              <div className="buttons right nowrap">
                                {["admin", "artist", "agent", "organization"].includes(role) && (
                                  <Link to={`/artist/bookings/${item.$id}?page=${currentPage}`} className='button small green' title="Bookings"> <span className="icon"><i className="mdi mdi-book-multiple"></i></span></Link>
                                )}

                                {["admin", "artist", "agent", "organization"].includes(role) && (
                                  <Link to={`/artist/edit/${item.$id}?page=${currentPage}`} className='button small green' title="Edit"> <span className="icon"><i className="mdi mdi-lead-pencil"></i></span></Link>
                                )}

                                <button
                                  className="button small red"
                                  type="button"
                                  onClick={() => {
                                    if (deleting) return;
                                    setDeleteId(item.$id);
                                    setShowPopup(true);
                                  }}
                                  style={{
                                    cursor: deleting ? "not-allowed" : "pointer",
                                    opacity: deleting ? 0.5 : 1
                                  }}
                                >
                                  <span className="icon" title="Delete"><i className="mdi mdi-trash-can"></i></span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {totalPages > 1 && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalRecords={totalArtists}
                        onPageChange={(page) =>
                          setSearchParams({
                            page
                          })
                        }
                      />
                    )}
                  </>
                ) : (
                  <p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}>No Record Found.</p>
                )

              )}
            </div>
          </div>
        </div>
      </div>
      {/* Confirmation Popup */}
      <ConfirmationPopup
        show={showPopup}
        onConfirm={handleDelete}
        onCancel={() => {
          if (!deleting) {
            setShowPopup(false);
          }
        }}
        title="Confirm Delete"
        message={
          deleting
            ? "Deleting artist..."
            : "Are you sure you want to delete this artist?"
        }
        deleting={deleting}
      />
    </section >
  );
};

export default Artists;